import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getCachedSession } from "../auth/client";

/**
 * Pending-account shell for waitlist lifecycle routes.
 * Contract: only pending users can render child content; active users and
 * anonymous sessions are redirected before route children mount.
 */
export const Route = createFileRoute("/_pending")({
  component: Outlet,
  beforeLoad: async () => {
    const { data } = await getCachedSession();
    // If not logged in, redirect to login
    if (!data) {
      throw redirect({ to: "/login" });
    }
    // If user is active, redirect to home
    if (data.user.status === "active") {
      throw redirect({ to: "/home" });
    }
    // Otherwise, show pending content
    return { session: data.session, user: data.user };
  },
});
